module.exports = __webpack_public_path__ + "static/media/tianshangshan_plant.c9a2efed.webp";